var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.languages
    ? _c(
        "w-row",
        [
          _c("w-tabs", {
            attrs: { tabs: _vm.tabs },
            model: {
              value: _vm.active,
              callback: function ($$v) {
                _vm.active = $$v
              },
              expression: "active",
            },
          }),
          _c(
            "w-col",
            {
              key: _vm.lang,
              staticClass: "mt",
              style: { marginTop: "5px" },
              attrs: { xs: "12" },
            },
            [
              _vm.value && _vm.showEditor
                ? _c("w-editor", {
                    attrs: {
                      height: "600",
                      value: _vm.value.Translations[_vm.lang] || "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onInput($event, _vm.lang)
                      },
                    },
                  })
                : _vm._e(),
              !_vm.showEditor
                ? [
                    !_vm.useTextarea
                      ? _c("w-input", {
                          attrs: { label: _vm.getLabel(_vm.lang), fancy: "" },
                          model: {
                            value: _vm.value.Translations[_vm.lang],
                            callback: function ($$v) {
                              _vm.$set(_vm.value.Translations, _vm.lang, $$v)
                            },
                            expression: "value.Translations[lang]",
                          },
                        })
                      : _c("w-textarea-autogrow", {
                          attrs: {
                            value: _vm.value.Translations[_vm.lang] || "",
                            label: _vm.getLabel(_vm.lang),
                            fancy: "",
                            "min-height": 150,
                            "max-height": _vm.maxHeight,
                          },
                          on: {
                            input: function ($event) {
                              _vm.value.Translations[_vm.lang] = $event
                            },
                          },
                        }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }